var _rect, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusdotRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 4.2517,
    fill: "#FDE0E4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.10547,
    cy: 8,
    r: 4,
    fill: "#FA5A7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusdotRed);
export default __webpack_public_path__ + "static/media/statusdot-red.023ce6a738a8e492ff2ba743f68bba1e.svg";
export { ForwardRef as ReactComponent };